import React from 'react';
import App from './App';
import './App.scss';
import './styles/global.scss';
// vaul は package exports に style.css が無いため相対パスで読み込む
import '../node_modules/vaul/style.css';
import './i18n';
import { registerSW } from 'virtual:pwa-register';
import { createRoot, hydrateRoot } from 'react-dom/client';

// Sentryの初期化
import * as Sentry from '@sentry/react';
Sentry.init({
    dsn: 'https://9eeea2eba0c638551fba3d75eee41fd3@o4509285322260480.ingest.us.sentry.io/4509285328093184',
    sendDefaultPii: true,
    environment: import.meta.env.MODE, // dev/staging/productionなど自動取得
    release: 'kotomil@1.0.0', // 必要なら環境変数化も可
});

const container = document.getElementById('root');
const app = (
    <React.StrictMode>
        {/* SentryのErrorBoundaryでAppを囲む */}
        <Sentry.ErrorBoundary fallback={<p>エラーが発生しました</p>}>
            <App />
        </Sentry.ErrorBoundary>
    </React.StrictMode>
);

if (container?.hasChildNodes()) {
    hydrateRoot(container, app);
} else if (container) {
    // Dev server / 未プリレンダリング環境では通常のCSRとしてレンダリングする
    createRoot(container).render(app);
} else {
    // eslint-disable-next-line no-console
    console.error('Root container not found');
}

// PWA対応：サービスワーカーを登録
registerSW();
